module.exports = __webpack_public_path__ + "static/media/login.346fe23a.svg";